import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
var tl = gsap.timeline();
gsap.registerPlugin(ScrollTrigger);
export var gsapFromTo = function (ref, configs) {
    return gsap.fromTo(ref, configs === null || configs === void 0 ? void 0 : configs.config, configs === null || configs === void 0 ? void 0 : configs.config2);
};
export var gsapFrom = function (ref, configs) {
    return gsap.from(ref, configs === null || configs === void 0 ? void 0 : configs.config);
};
export var gsapTo = function (ref, configs) { return gsap.to(ref, configs === null || configs === void 0 ? void 0 : configs.config); };
export var gsapTimelineFromTo = function (ref, configs, delay) {
    return tl.fromTo(ref, configs === null || configs === void 0 ? void 0 : configs.config, configs === null || configs === void 0 ? void 0 : configs.config2, delay);
};
export var gsapTimelineFrom = function (ref, configs, delay) {
    return tl.from(ref, configs === null || configs === void 0 ? void 0 : configs.config, delay);
};
export var gsapTimelineTo = function (ref, configs, delay) {
    return tl.to(ref, configs === null || configs === void 0 ? void 0 : configs.config, delay);
};
